/**
 * A helper function to decide the current env, ie browser/server.
 * @return {Boolean} true/false
 */
export const isServer = () => {
  return __SERVER__ === true // eslint-disable-line
}

/**
 * A helpful funciton to decide the current env, ie production/development
 * @return {Boolean} true/false
 */
export const isProduction = () => {
  return process.env.NODE_ENV === 'production'
}

export const isDevelopment = () => {
  return process.env.NODE_ENV === 'development'
}

export const isE2ETest = () => {
  return process.env.NODE_ENV === 'e2e_test' || process.env.E2E_TEST
}

export const hasWindow = () => {
  return typeof window !== 'undefined'
}

export const getEnv = () => {
  if (isProduction()) return 'production.env'
  if (isE2ETest()) return 'e2e.env'

  return '.env'
}
